import Loader from "../common/Loader";
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

const RedirectHome = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <Loader />;

  return isAuthenticated ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default RedirectHome;
